
























































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Carousel extends Vue {
  private items: any

  constructor() {
    super()

    this.items = [
      {
        src: '/assets/img/slider/3.jpeg'
      }
      // {
      //   src: '/assets/img/slider/4.jpg'
      // }
      // {
      //   src: "/assets/img/slider/1.jpg"
      // }
    ]
  }
}
